/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Fit_FeatureInputs */

const en_directory_comparison_product_hunt_rows_fit_feature = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Fit_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Seek AI when`)
};

const zh_directory_comparison_product_hunt_rows_fit_feature = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Fit_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合使用 Seek AI 的情况`)
};

/**
* | output |
* | --- |
* | "Use Seek AI when" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Fit_FeatureInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_fit_feature = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Fit_FeatureInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Fit_FeatureInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_fit_feature(inputs)
	return zh_directory_comparison_product_hunt_rows_fit_feature(inputs)
});
export { directory_comparison_product_hunt_rows_fit_feature as "directory.comparison.product_hunt.rows.fit.feature" }